<template>
    <li class="label-value-item" >
        <div class="the-label" :class="[brandColor, {'has-drawing-code': withDrawingCode && labelValue.drawingCode}]">
            <div class="drawing-code-container" v-if="withDrawingCode && labelValue.drawingCode">
                <div class="drawing-code">
                    {{ labelValue.drawingCode }}
                </div>
            </div>
            <div class="label-text">
                {{ labelValue.label }}
            </div>
        </div>
        <span class="dots"></span>
        <span class="value">{{ labelValue.value }}</span>
    </li>
</template>

<script>
    export default {
        name: 'LabelValueItem',
        props: {
            labelValue: {
                type: Object,
                required: true
            },
            withDrawingCode: {
                type: Boolean,
                required: false,
                default: false
            },
        },
    }
</script>

<style lang="scss">
.label-value-item {
    position: relative;
    display: flex;
    margin-bottom: 30px;
    min-height: 30px;
    font-size: 15px;
    background-image: url('~@/assets/img/spaced-dot.svg');
    background-position: center center;
    background-repeat: repeat-x;
    background-size: 7px 2px;

    @media #{$mq_phone} {
        display: block;
        background: none;
        margin-bottom: 35px;
    }

    .the-label {
        display: flex;
        align-items: center;
        background-color: $white;

        @media #{$mq_phone} {
            display: block;
        }

        &.has-drawing-code {
            flex-direction: column;
            justify-content: flex-start;
            margin-top: 6px;
        }

        .drawing-code-container {
            flex: 0;

            .drawing-code {
                position: absolute;
                top: -20px;
                left: 0;
                display: inline-block;
                align-items: center;
                justify-content: center;
                background-color: $blackish;
                border-radius: 100px;
                color: $white;
                font-size: 12px;
                margin-bottom: 5px;
                padding: 5px 8px 5px 11px;
                letter-spacing: 0.9px;

                @media #{$mq_phone} {
                    top: -22px;
                    padding: 3px 8px 3px 11px;
                }
            }
        }

        .label-text {
            padding-right: 10px;
        }
    }

    .dots {
        flex: 1 1 auto;

        @media #{$mq_phone} {
            display: none;
        }
    }

    .value {
        display: flex;
        align-items: center;
        width: 200px;
        padding-left: 10px;
        background-color: $white;
        color: $medium-grey;

       @media #{$mq_small_desktop} {
           width: 50px;
       }

        @media #{$mq_phone} {
            display: block;
            width: 100%;
            padding-left: 0;
            margin-top: 5px;
        }
    }
}
</style>
